import React, { Component } from 'react';

import { Link } from 'react-router-dom';

export default class Home extends Component {
    static displayName = Home.name;

    componentDidMount() {
        
    }
    render() {
        const signinout = this.props.authed ?
            (<div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="card">
                            <h5 class="card-header">Getting Started with Collections</h5>
                            <div class="card-body">
                                <p class="card-text">Collections are lists of Google Documents which define a Table of Contents in your GStitch presentation.  Get started by adding or editing a Collection.</p>
                                <Link to="/lists" class="btn btn-secondary">Add or Edit Collections</Link>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="card">
                            <h5 class="card-header">Managing Teams</h5>
                            <div class="card-body">
                                <p class="card-text">Setup your Team and invite users.  Premium accounts enable you to brand your GStitch presentation. Collections you add and edit belong to your Active Team.</p>
                                <Link to="/teams" class="btn btn-secondary">Manage Teams</Link>
                            </div>
                        </div>
                    </div>
                </div>

            </div>) :
            (<div className="col-md-3">
                <Link className="button" to={{
                    pathname: '/login'
                }} >
                    Login
                        </Link>
            </div>) ;

                return (
                    <div>
                        <h6 class="alert alert-light">
                            Welcome to gstitch. We stitch together Google documents to create
                            cohesive and impressive documentation that you can present to your users.
                        </h6>
                        <div className="container-fluid">
                            <div className="row">
                             
                                {signinout}
                            </div>
                        </div>
                    </div>
        );
    }
}
